import { useGetActionsQuery } from "./actionsApiSlice"
import PulseLoader from 'react-spinners/PulseLoader'
import { Link, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAdd, faPenToSquare } from "@fortawesome/free-solid-svg-icons"

const ActionsList = () => {
    const { taskId, groupId, type } = useParams()
    const {
        data: actions,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetActionsQuery('actionsList', {
        refetchOnMountOrArgChange: false,
    })
   
    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = actions
        const filteredIds =  ids.filter(actionId => entities[actionId].task === taskId)


        const tableContent = ids?.length && filteredIds.map(actionId =>{
            const action = entities[actionId]
            const cellStatus = action.active ? '' : 'table__cell--inactive'

            return(
            <tr key={actionId} className={`table__row`}>
            <td className={`table__cell ${cellStatus}`}> {action.title} {action.ratio? `(${action.ratio}%)`:""} <hr /> <small> {action.text}</small></td>
            {/* <td className="table__cell edit-action__type">{action.type}</td> */}
            <td className={`table__cell ${cellStatus}`}>
               <Link className="icon-button table__button" to={`/${type}/${groupId}/tasks/${action.task}/action/${action.id}`}>
               <FontAwesomeIcon icon={faPenToSquare}  />
               </Link>           
              
                                              
            </td>
        </tr>)

           })

        content = (
            <> 
           
            <table className="table table--edit-actions">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th edit-action__text th-with-buttons">
                         <span>דרישות</span>
                        <Link className="table__button" to={`/${type}/${groupId}/tasks/${taskId}/action/new`}>
                            <FontAwesomeIcon icon={faAdd} />הוספת דרישה
                        </Link>
                        </th>
                        {/* <th scope="col" className="table__th edit-action__type">סוג</th> */}
                        <th scope="col" className="table__th edit-action__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default ActionsList